import { createClient } from "@supabase/supabase-js";

const supabaseUrl =
  import.meta.env.VITE_SUPABASE_URL ||
  "https://dsvvpnzwhhcfcjuhhlxz.supabase.co";
const supabaseAnonKey =
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRzdnZwbnp3aGhjZmNqdWhobHh6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgxODM0NDEsImV4cCI6MjA2Mzc1OTQ0MX0.LlOW__MYxYqQNlyjZ7CGn55_pmGerk58QBtXgwD4k7Q";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
